let ws = null
let pingTimer = null
let reconnectTimer = null
let reconnectDelay = 3000
let manualClose = false

const listeners = new Set()

// 发送队列
let sendQueue = []

export function createWS(url) {
    if (ws) return ws

    ws = new WebSocket(url)

    ws.onopen = () => {
        reconnectDelay = 3000
        startPing()
        console.log('[WS] connected')

        flushSendQueue()
    }

    ws.onmessage = e => {
        let msg
        try {
            msg = JSON.parse(e.data)
        } catch {
            return
        }
        listeners.forEach(fn => fn(msg))
    }

    ws.onerror = err => {
        console.error('[WS] error', err)
    }

    ws.onclose = () => {
        console.log('[WS] closed')
        stopPing()
        reconnect(url)
    }

    return ws
}

/* ========== ping ========== */
function startPing() {
    stopPing()
    pingTimer = setInterval(() => {
        if (ws?.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify({ action: 'ping' }))
        }
    }, 30000)
}

function stopPing() {
    if (pingTimer) {
        clearInterval(pingTimer)
        pingTimer = null
    }
}

/* ========== reconnect ========== */
function reconnect(url) {
    if (manualClose) return

    reconnectTimer && clearTimeout(reconnectTimer)

    reconnectTimer = setTimeout(() => {
        ws = null
        createWS(url)
        reconnectDelay = Math.min(reconnectDelay * 2, 30000)
    }, reconnectDelay)
}

/* ========== send queue ========== */
function flushSendQueue() {
    if (!ws || ws.readyState !== WebSocket.OPEN) return

    while (sendQueue.length) {
        const data = sendQueue.shift()
        ws.send(JSON.stringify(data))
    }
}

/* ========== API ========== */
export function send(data) {
    if (!ws || ws.readyState !== WebSocket.OPEN) {
        // 未连接 → 进入队列
        sendQueue.push(data)
        return
    }

    ws.send(JSON.stringify(data))
}

export function onMessage(fn) {
    listeners.add(fn)
    return () => listeners.delete(fn)
}

export function closeWS() {
    manualClose = true
    stopPing()
    reconnectTimer && clearTimeout(reconnectTimer)

    ws?.close()
    ws = null
    sendQueue = []
}
